module.exports = __webpack_public_path__ + "static/media/tattoo-selected.7477ae39.png";